import {requirePermission} from '@/modules/auth/permissions'
// oxlint-disable no-non-null-assertion
import {useGetInfiniteWards} from '@/modules/wards/api'
import {WardsTable} from '@/modules/wards/components'
import {WardsFilters} from '@/modules/wards/components/wards-filters'
import {WardsSearchSchema} from '@/modules/wards/schemas'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {HStack} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'
import {LuPlus} from 'react-icons/lu'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'
import {type OnChangeFn, type SortingState} from '@tanstack/react-table'

export const Route = createFileRoute('/configuration/wards/')({
  beforeLoad: requirePermission('organisation.manage'),
  component: WardsPage,
  validateSearch: WardsSearchSchema,
})

const LIMIT = 50

function WardsPage() {
  const {t} = useTranslate('common')
  const navigate = Route.useNavigate()
  const search = Route.useSearch()
  const [sort] = search.sort

  const infiniteWards = useGetInfiniteWards({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
    filters: {
      name: search.filters?.search,
      sectionId: search.filters?.sections,
      status: [],
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infiniteWards

  const onSortingChange = useCallback<OnChangeFn<SortingState>>(
    updaterOrValue => {
      const newValue = typeof updaterOrValue === 'function' ? updaterOrValue(search.sort) : updaterOrValue
      navigate({to: '.', search: prev => ({...prev, sort: newValue})})
    },
    [navigate, search.sort]
  )

  return (
    <>
      <HStack justifyContent="space-between" width="100%">
        <LinkButton to="/configuration/wards/new" marginY="1rem" colorPalette="cyan" size="sm">
          <LuPlus />
          {t('add_new')}
        </LinkButton>

        <WardsFilters />
      </HStack>
      <ResourcesIndexPageTable>
        <WardsTable
          virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
          table={{onSortingChange, state: {sorting: search.sort}}}
        />
      </ResourcesIndexPageTable>
    </>
  )
}
